module.exports = __webpack_public_path__ + "img/detrascan.3b4dd3c.png";